<ng-template [ngIf]="isOpen">
  <div class="modal-overlay" (ls-outside-click)="close()">
    <ng-template #dynamicComponentContainer></ng-template>
    <div class="modal-backdrop" (click)="close()"></div>
  </div>
</ng-template>
